
import React, { useState, useCallback, useEffect, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import Row from '../../../components/Row'
import { getArtist } from '../../../service/user'
import { useActiveWeb3React } from '../../../hooks'
import ArtistCard from './ArtistCard'
import { userInfoProps } from '../../../constants/usercenter'
import { userInfo } from '../../../constants/usercenter'

// swiper
import { windowSize } from '../../../utils/func'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

const FeaturedArtistWapper = styled.div`
  padding: 40px 0px 64px;
  margin-top: 64px;
  position: relative;
  &:before{
    content: '';
    opacity: ${({ theme }) => theme.darkMode ? '0.12' : 1};
    background: ${({ theme }) => theme.darkMode ? 'radial-gradient(135.69% 135.92% at 51.27% 41.22%, #FF7EB5 0%, #E486E0 17.98%, #D18CFF 32.8%, #00B7FF 52.4%, #A9F4B1 72.98%, #FFDB63 100%)' : '#ffffff'};
    top:0;
　　 left:0;
 　　bottom:0;
 　　right:0;
 　　position:absolute;
  }
`

const FeaturedArtistContent = styled.div`
  max-width: 1440px;
  margin: auto;
  position: relative;
  box-sizing: border-box;
  padding: 0px 25px;
`

const NextRightIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  right: 0px;
  top: 130px;
  cursor: pointer;
`

const PrevLeftIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  left: 0px;
  top: 130px;
  cursor: pointer;
`


const Title = styled(Row)`
  
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${({ theme }) => theme.bsText32};
`
const SwiperWrapper = styled(Row)`
  display: flex;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  justify-content: flex-start;
  grid-template-columns: repeat(auto-fill, 272px);
  flex-wrap: nowrap;
  overflow: auto;
  margin-top: 40px;
  max-width: 100%;
  min-height: 223px;
  .swiper-pagination {
    display: none;
  }
  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.9);
  }
  .swiper-pagination-bullet-active {
    background: #fffdfa;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`

const ArtistWrapper = styled.div`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    transform: scale(0.7);
  `}
`


export default function FeaturedArtists() {
  const theme = useContext(ThemeContext)
  const [loading, setLoading] = useState(false)
  const { chainId } = useActiveWeb3React()
  const [artistData, setArtistData] = useState<any[]>([])

  const fetchArtists = useCallback(() => {
    setLoading(true)
    getArtist(chainId as number, {addressTypes: '4'}, (err: any, d: any) => {
      if (err) return
      if (d.code !== 0) return
      if (!err && d.code === 0) {
        const list = d.data || []
        const data = list.length ? list : userInfo
        const artists = data.map((d: userInfoProps) => {
          return{
            nick: d.nick,
            avatar: d.avatar,
            address: d.address
          }
        })
        setArtistData(artists)
      } else {
        setArtistData(userInfo as any)
      }
      setLoading(false)
    })
  }, [getArtist, chainId])

  useEffect(() => {
    fetchArtists()
  }, [fetchArtists])


  // swiper
  const upToSmall = 500
  const upToMedium = 960
  const upMoreMedium = 1300
  const upToExtraLarge = 1440
  const upToLessLarge = 1520
  const upToMoreLarge = 1600
  const upToLarge = 1750
  const emptySwiper: any = null
  const [swiper, setSwiper] = useState(emptySwiper)
  const [width, setWidth] = useState(windowSize().w)
  const params = {
    loop: true,
    slidesPerView: 6.5,
    spaceBetween: 16,
    pagination: {
      clickable: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    observer: true,
    observeParents: true,
    onSwiper: setSwiper
  }
  useEffect(() => {
    if (swiper) {
      if(width <= upToSmall){
        swiper.params.slidesPerView = 2.8
        swiper.params.spaceBetween = 16
      }else if(width <= upToMedium){
        swiper.params.slidesPerView = 5
        swiper.params.spaceBetween = 16
      }else if(width <= upMoreMedium){
        swiper.params.slidesPerView = 6.5
        swiper.params.spaceBetween = 16
      }else if(width <= upToExtraLarge){
        swiper.params.slidesPerView = 7.8
        swiper.params.spaceBetween = 16
      }else if(width <= upToLessLarge){
        swiper.params.slidesPerView = 8.4
        swiper.params.spaceBetween = 16
      }else if(width <= upToMoreLarge){
        swiper.params.slidesPerView = 8.8
        swiper.params.spaceBetween = 16
      }else if(width <= upToLarge){
        swiper.params.slidesPerView = 9.2
        swiper.params.spaceBetween = 16
      }else{
        swiper.params.slidesPerView = 9.5
        swiper.params.spaceBetween = 16
      }
      swiper.autoplay.stop()
    }
  }, [width, swiper])

  const handleResize = useCallback(() => {
    const size = windowSize()
    setWidth(size.w)
  }, [width])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  const slideNext = useCallback(() => {
    swiper.slideNext()
  }, [swiper])

  const slidePrev = useCallback(() => {
    swiper.slidePrev()
  }, [swiper])
  

  useEffect(() => {
    if(swiper){
      swiper.slideTo(7, 1000, true);
    }
  }, [swiper, chainId])

  return (
    <FeaturedArtistWapper>
      <FeaturedArtistContent>
        <Title>
          Featured Artists
        </Title>
        <SwiperWrapper>
          <Swiper {...params}>
            {
              loading ? (
                <Text
                  marginTop={20} 
                  textAlign={'center'} 
                  fontFamily={'Baloo Da'}>
                    loading...
                </Text>
              ) : artistData.map((d:any, index: any) => {
                return (
                  <SwiperSlide key={index}>
                    <ArtistWrapper>
                      <ArtistCard artist={d}></ArtistCard>
                    </ArtistWrapper>
                  </SwiperSlide>
                )
              })
            }
          </Swiper>
        </SwiperWrapper>
        <NextRightIcon src={theme.darkMode ? "/images/icon/next-dark.png" : "/images/icon/next.png"} onClick={slideNext}/>
        <PrevLeftIcon src={theme.darkMode ? "/images/icon/prev-dark.png" : "/images/icon/prev.png"} onClick={slidePrev}/>
      </FeaturedArtistContent>
    </FeaturedArtistWapper>
  )
}

